export const getInitialFinderPath = (router, route) => {
  let initialPath = '';
  if (route.name.includes('project')) {
    // FIXME - review this once we decide a consistent approach for URLs.
    // We currently allow characters with accents and other utf8 characters as part of project names
    // which can be a source of issues.
    // Here we use the router to extract the URL path, which ends up encoding some characters.
    initialPath = `${router
      .buildUrl(`${route.name.split('.')[0]}.project`, route.params)
      .substring(1)}/`;
    initialPath = decodeURI(initialPath);
  }
  return initialPath;
};
